import React, { Component } from "react";
import { Button, Carousel, Popover } from "antd";
import { Alert, Images } from "../../../components";
import { AppConfig } from "../../../helpers";
import moment from "moment";
import { connect } from "react-redux";
import { getDrawOdds } from "../../../redux/actions/sportTypesActions";
import { ReactSVG } from "react-svg";
import { ManageMemeberFavorite } from "../../../redux/actions/membersActions";
import { UpdateFavoriteForLuckyNumber } from "../../../redux/actions/sportTypesActions";
class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countdown: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      isFaviorite: this.props.item.isFavorite,
    };
  }

  componentDidMount() {
    this.updateCountdown();
    this.countdownInterval = setInterval(this.updateCountdown, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
  }

  updateCountdown = () => {
    const now = moment.utc();
    const targetDate = moment.utc(this.props.date);

    if (now.isAfter(targetDate)) {
      // Date has already passed, set countdown to zero
      this.setState({
        countdown: {
          hours: "00",
          minutes: "00",
          seconds: "00",
        },
      });
      clearInterval(this.countdownInterval);
    } else {
      const duration = moment.duration(targetDate.diff(now));
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      this.setState({
        countdown: {
          hours: hours < 10 ? "0" + hours : hours,
          minutes: minutes < 10 ? "0" + minutes : minutes,
          seconds: seconds < 10 ? "0" + seconds : seconds,
        },
      });
    }
  };
  calculateDays = (hours) => {
    if (hours <= 24) {
      return "00";
    } else {
      let days = Math.floor(hours / 24);
      return days.toString().padStart(2, "0");
    }
  };

  navToSingleMatch = (eventId) => {
    const { history, match } = this.props;
    history.push(`/lucky-numbers/15/108/drilldown/${eventId}`);
  };

  addToFavorate = (favItem) => {
    const { ManageMemeberFavorite , UpdateFavoriteForLuckyNumber} = this.props;
    const favItemKey = `2-${favItem.eventTournament && favItem.eventTournament.tournamentId}-${favItem.sport && favItem.sport.sportId}`
    const memberFavorites= localStorage.getItem('memberFavorites') && JSON.parse(localStorage.getItem('memberFavorites'))
    const existingIndex = memberFavorites.findIndex(item => item.key === favItemKey);
    const elementId = favItem.eventTournament && favItem.eventTournament.tournamentId
    if (existingIndex > -1) {
      let element = memberFavorites.filter((item)=>item.key == favItemKey)
      let data ={
        favoriteId: element[0].favoriteId,
        favoriteType: {
          favoriteTypeId: 2,
        },
        feedId: 15,
        sportId: 108,
        elementId: elementId,
      }
      ManageMemeberFavorite(data);

    } else {
      let data ={
        favoriteType: {
          favoriteTypeId: 2,
        },
        feedId: 15,
        sportId: 108,
        elementId: elementId,
      }
      ManageMemeberFavorite(data);

    }
    UpdateFavoriteForLuckyNumber(elementId)
    // this.setState({
    //   isFaviorite: !this.state.isFaviorite,
    // });
  };

  render() {
    const { idx, eventId, enableBet, signedIn, item } = this.props;

    const { hours, minutes, seconds } = this.state.countdown;
    const closeBet = hours === "00" && minutes == "00" && seconds == "00";
    const isFavorite = this.props.item && this.props.item.isFavorite

    return (
      <div
        key={eventId}
        className={`slides`}
        style={this.props.betCard ? { width: "unset" } : {}}
      >
        <div className="slide-header">{this.props.name}</div>
        <div className="slide-body">
          <div className="eventid-container"> ID : {eventId}</div>
          <div className="team-container">
            <img
              src={
                AppConfig.countryFlagImagesPath +
                (this.props.flagCode ? this.props.flagCode : `eu`) +
                `.webp`
              }
              alt="country-flag"
            />
            <div className="match-time">
              {hours > 24 && (
                <div className="time">
                  <div className="number">{this.calculateDays(hours)}</div>
                  <div className="label">Day</div>
                </div>
              )}
              <div className="time">
                <div className="number">{hours}</div>
                <div className="label">Hour</div>
              </div>
              <div className="time">
                <div className="number">{minutes}</div>
                <div className="label">MIN</div>
              </div>
              <div className="time">
                <div className="number">{seconds}</div>
                <div className="label">SEC</div>
              </div>
            </div>
          </div>
          <div className="bet-container">
            <Button
              disabled={!enableBet}
              className={!enableBet && "bets-closed"}
              onClick={() => eventId && this.navToSingleMatch(eventId)}
            >
              {!enableBet ? `BETS CLOSED` : `BET NOW`}
            </Button>
          </div>
          <div className="star-container">
            {!signedIn ? (
              <Popover
                overlayClassName="popup-slots"
                placement="bottom"
                arrowPointAtCenter
                content={<p> Please Sign in or Register </p>}
                trigger="click"
              >
                <img src={Images.LuckyNumberStar} />
              </Popover>
            ) : (
              <ReactSVG
                className={`${(isFavorite) &&
                  `favorite-icon-selected`}`}
                src={Images.LuckyNumberStar}
                onClick={() => this.addToFavorate(item)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    connected: state.signalr.luckyNumbersConnected,
    signedIn: state.auth.signedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ManageMemeberFavorite: (data) => {
      dispatch(ManageMemeberFavorite(data));
    },
    UpdateFavoriteForLuckyNumber: (tournamentId) => {
      dispatch(UpdateFavoriteForLuckyNumber(tournamentId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Card);
